var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlitzMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-10.75 -12 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7971 13.5391L0 17.0893L8.66595 24.9578L12.7971 21.9963V13.5391Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99463 25.732L12.7969 37.8773V22.8945L8.99463 25.732Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0762 18.9446C39.6675 17.07 41.2191 14.1558 41.2428 10.7985C41.2822 4.81835 36.322 0 30.3419 0H16.1271C14.288 0 12.7974 1.4906 12.7974 3.32972V13.5394L29.8063 8.8215C30.2533 8.69745 30.5349 9.28818 30.1588 9.55794L12.7974 21.9967V22.8946L30.2041 10.4243C30.5782 10.1565 31.0468 10.6075 30.7909 10.9914L12.7993 37.8773C12.7993 39.0489 13.7504 40 14.922 40H30.8952C37.3341 40 42.6408 34.7642 42.5207 28.3253C42.4459 24.3162 40.4039 20.9609 37.0782 18.9446H37.0762Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlitzMark);
export default __webpack_public_path__ + "static/media/blitz-mark.cb8deb4ba8c18b7ac4ed2c62a133609a.svg";
export { ForwardRef as ReactComponent };